require('./bootstrap');


//require jquery
//global.$ = global.jQuery = require('jquery');


import jQuery from 'jquery';
window.$ = jQuery;
import 'jquery-ui/ui/widgets/sortable';
